export const TITLE = 'Job Settings';

export const JOB_SETTINGS_OPTIONS = [
  { name: 'Build quotes with Ideal4Finance', value: 'kanda' },
  { name: 'Use own quotes - Upload PDFs', value: 'custom' },
];
